import { Component, Input, Output, EventEmitter, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { ɵa } from 'ngx-filepond';
@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    encapsulation: ViewEncapsulation.None,
    // styles: [
    //   `
    //     :host >>> .filepond--root {
    //         font-family: 'Raleway', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    //             Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    //             'Segoe UI Symbol';
    //     }
    //     :host >>> .filepond--file-action-button.filepond--action-remove-item {
    //       background-color: gray !important;
    //     }

    //     :host >>> .filepond--item-panel {
    //       background-color: var(--blue)
    //     }

    //     :host >>> .subtext {
    //       font-size: 0.8em;
    //     }
    //     :host >>> .filepond--item {
    //       width: 200px !important;
    //       height: 500px !important;
    //   }

    // `
    // ],
})
export class FileUploadComponent implements OnInit {
    @Input('returnFileBase64String') flgFileBase64String: boolean;
    @Input('aceptedTypes') acceptedTypes: string;
    @Input('placeholder') placeholder: string;
    @Input('maxFileSize') maxFileSize: string;
    @Input('icon') icon: string;
    @Input('class') class?: string = '';

    @ViewChild('myPond', { static: false }) myPond: any;

    @Output() fileEvent = new EventEmitter<{}>();

    flg_config: boolean = false;
    // public uploader: FileUploader = new FileUploader({
    //   url: URL,
    // });

    file_form = {
        status: false,
        filename: null,
        filetype: null,
        fileext: null,
        file: null,
    };

    constructor() {
        // private toastr: ToastrService // private _fileService: FileService,
        this.flgFileBase64String = false;
        this.acceptedTypes = '*';
    }

    pondOptions = {};
    // getFileEncodeBase64String	Returns the base64 encoded file string
    // getFileEncodeDataURL	      Returns the base64 encoded file string in DataURL format
    pondFiles = [];

    ngOnInit() {
        // this.pondOptions.acceptedFileTypes = this.acceptedTypes;
        this.pondOptions = {
            // class: 'my-filepond',
            // multiple:true,
            allowMultiple: false,
            // labelIdle: 'Drop files here',
            labelIdle: this.placeholder
                ? this.placeholder
                : // : '<p class="filepond--text-action">Arrastre el archivo a esta área o <span class="filepond--label-action"> haz click aquí </span></p><p class="filepond--text-action-secondary">Máximo 5 MB - Formato CSV</p>',
                  '<p class="filepond--text-action">Arrastre el archivo a esta área o <span class="filepond--label-action"> haz click aquí </span></p><mat-icon class="w-[16.67px] h-[15px] min-w-[16.67px] min-h-[15px]" svgIcon="icons:buscar-icon"></mat-icon> <p class="filepond--text-action-secondary">Máximo 5 MB - Formato CSV</p>',
            allowReplace: true,
            maxFiles: 1,
            allowFileEncode: true,
            // acceptedFileTypes: 'image/jpeg, image/png'
            allowFileTypeValidation: true,
            // dropValidation:true,
            acceptedFileTypes: this.acceptedTypes, //'application/x-pkcs12,.pfx',
            credits: false,
            labelFileLoading: 'Cargando',
            labelFileLoadError: 'Ha ocurrido un error durante la carga',
            labelFileWaitingForSize: 'Esperando tamaño',
            labelFileSizeNotAvailable: 'Tamaño no disponible',
            labelFileTypeNotAllowed: 'Tipo de archivo incorrecto',
            fileValidateTypeLabelExpectedTypes: 'Se espera {allButLastType} o {lastType}',
            labelTapToCancel: 'toca para cancelar',
            labelTapToRetry: 'toca para reintentar',
            labelTapToUndo: 'toca para deshacer',
            fileValidateTypeLabelExpectedTypesMap: {
                'application/x-pkcs12': '.p12',
                pfx: '.pfx',
                'image/png': '.png',
                'image/jpeg': '.jpeg',
                'application/pdf': '.pdf',
                'text/xml': '.xml',
                'image/*': 'imagen',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
                'application/vnd.ms-excel': 'xls',
                'application/msword': '.doc',
                'application/vnd.ms-powerpoint': '.ppt',
            },
            allowImageExifOrientation: true,
            allowImagePreview: false,
            //imagePreviewMinHeight : 44,
            // imagePreviewMaxHeight : 256	,
            // imagePreviewTransparencyIndicator: '#f00'
            instantUpload: false,
            // server: null,
            // server: { url: URL },

            allowFileSizeValidation: true,
            maxFileSize: this.maxFileSize || '7MB',
            maxTotalFileSize: this.maxFileSize || '7MB',
            labelMaxFileSizeExceeded: 'El archivo es muy pesado',
            labelMaxFileSize: 'El tamaño maximo de archivo es {filesize}',
            labelMaxTotalFileSizeExceeded: 'Los archivos son muy pesados',
            labelMaxTotalFileSize: 'El tamaño maximo de los archivos es {filesize}',
        };
        this.pondFiles = [
            // 'assets/images/Credentials_Preview.png'
        ];
        this.flg_config = true;
    }

    pondHandleInit() {
        //console.log('FilePond has initialised', this.myPond)
    }

    pondHandleAddFile(event: any) {
        if (event.error) {
            this.file_form.status = false;
            this.file_form.filename = null;
            this.file_form.filetype = null;
            this.file_form.fileext = null;
            this.file_form.file = null;
            this.fileEvent.emit(this.file_form);
            return false;
        }
        // this.file_form.status = true;
        // this.file_form.filename = file.name;
        // this.file_form.file = file;

        this.file_form.status = true;
        this.file_form.filename = event.file.filename; //filenameWithoutExtension
        this.file_form.filetype = event.file.fileType;
        this.file_form.fileext = event.file.fileExtension;
        this.file_form.file = this.flgFileBase64String ? event.file.getFileEncodeBase64String() : event.file.file;
        this.fileEvent.emit(this.file_form);
        // console.log('A file was added', event.file);
        // file: (...)
        // fileExtension: (...)
        // fileSize: (...)
        // fileType: (...)
        // filename: (...)
        // filenameWithoutExtension: (...)
        // id: (...)
        // origin: (...)
        // serverId: (...)
        // source: (...)
        // status: (...)
        // transferId: (...)
        // this.fileEvent.emit(this.file_form);
        // event.file.getFileEncodeBase64String();
    }

    pondHandleRemoveFile(event: any) {
        this.file_form.status = false;
        this.file_form.filename = null;
        this.file_form.filetype = null;
        this.file_form.fileext = null;
        this.file_form.file = null;
        this.fileEvent.emit(this.file_form);
        // console.log('A file was deleted', event);
    }

    public resetFilePondFiles(): void {
        this.myPond.removeFiles({ revert: false });
    }

    //buscarPond() {
    //  debugger
    //  let archivos = this.myPond.getFiles();
    //  if (archivos.length > 0) {
    //    var my_string = archivos[0].getFileEncodeBase64String();
    //  }
    //}
}
